import * as React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";

export default function InputWithSelect({
  title,
  value,
  selectValue,
  name,
  selectName,
  handleChange,
  options,
  clearable = true,
  handleSaveData,
  error,
  disabled = false,
  size = "small",
  required = false,
}) {
  const handleOnChange = (e) => {
    handleChange(e);
    handleSaveData(e);
  };
  return (
    <Box
      sx={{
        bgcolor: disabled
          ? "var(--palette-disabled_button)"
          : "var(--palette-grid_table)",
      }}
    >
      <TextField
        name={name}
        label={title}
        required={required}
        size={size}
        fullWidth
        variant={"outlined"}
        value={value}
        onChange={handleChange}
        onBlur={handleSaveData}
        disabled={disabled}
        InputLabelProps={{
          style: {
            color: disabled
              ? "var(--palette-disabled_button_text)"
              : "var(--palette-grey_text)",
          },
        }}
        InputProps={{
          sx: { paddingLeft: "0px", color: "var(--palette-text)" },
          startAdornment: (
            <InputAdornment position="start">
              <BasicSelect
                options={options}
                name={selectName}
                value={selectValue}
                onChange={handleOnChange}
                clearable={clearable}
                disabled={disabled}
              />
            </InputAdornment>
          ),
        }}
        FormHelperTextProps={{
          sx: { position: "absolute", mt: 0, bottom: "-20px" },
        }}
        {...(error && { error: !!error, helperText: error })}
      />
    </Box>
  );
}

function BasicSelect({ name, value, onChange, options, clearable, disabled }) {
  return (
    <Select
      name={name}
      value={value}
      sx={{
        minWidth: "85px",
        width: "85px",
        height: "35px",
        "& .Mui-disabled": {
          color: "var(--palette-disabled_button_text)",
          WebkitTextFillColor: "var(--palette-disabled_button_text)",
        },
        "& .MuiSelect-icon": {
          color: disabled
            ? "var(--palette-disabled_button_text)"
            : "var(--palette-text)",
        },
        "& fieldSet": {
          borderLeft: "none",
          borderTop: "none",
          borderBottom: "none",
          borderRadius: "unset",
        },
        "& .MuiSelect-select": {
          color: "var(--palette-text)", // Set the desired color for the underline here
        },
      }}
      disabled={disabled}
      onChange={onChange}
    >
      {clearable ? <MenuItem value="none">Select</MenuItem> : null}
      {options &&
        options.map((opt, index) => (
          <MenuItem key={index} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
    </Select>
  );
}
